import { formatDate } from '../../lib/format';

/**
 * "2h ago" rather than a timestamp — the point of a catch-up feed is "how
 * long was I away", which a clock time does not answer at a glance. Falls
 * back to `formatDate` (from the shared, not-mine-to-edit `lib/format.ts`)
 * past a week, where "12d ago" stops being more readable than a date.
 */
export function formatRelativeTime(timestamp: string): string {
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '—';

  const seconds = Math.round((Date.now() - date.getTime()) / 1000);
  if (seconds < 45) return 'just now';

  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.round(hours / 24);
  if (days < 7) return `${days}d ago`;

  return formatDate(timestamp);
}
